
const ReportsData = [
    {
      id: 1,
      title: "Harnessing the Power of Data to Transform Cancer Research, Care and Innovation Across the Island of Ireland",
      authors: "Lawler M, Culhane A, Heenan D, Keatley D, Bennett D, Gaynor S, Lowery M, McCabe S",
      date: "May 2025",
      description: "This urgent Call to Cancer Data Action provides evidence to encourage political leaders across the island of Ireland to fast track its digital transformation to deliver better health and well-being, greater societal benefit, and enhanced economic advantages.",
      imageUrl: "https://i.ibb.co/9PPv1vp/Aedin-and-Mark-2.jpg",
      imageCaption: "Professor Aedin Culhane and Professor Mark Lawler",
      pdfUrl: "https://raw.githubusercontent.com/eHealthHub4Cancer/Harnessing-the-Power-of-Data-to-Transform-Cancer-Research/main/Harnessing%20the%20Power%20of%20Data%20for%20Cancer%2005-25%20090525%20Digital.pdf"
    }
    // You can add more reports here in the future
  ];
  
  export default ReportsData;